// extracted by mini-css-extract-plugin
export default {"status":"dJh0VHJ53d","online":"rS8+Rd6nBo","icon":"Z4Tg9ICRNv","checking":"OgqPuQioBl","offline":"XQoU82ghhL"};